import { Component, OnDestroy, Output, EventEmitter, Input, SimpleChanges, OnChanges } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { ReplaySubject } from 'rxjs';

@Component({
  selector: 'name-card',
  templateUrl: './name-card.component.html',
  styleUrls: ['./name-card.component.scss'],
  standalone: false,
})
export class NameCardComponent implements OnDestroy, OnChanges {
  private destroyed$ = new ReplaySubject<boolean>(1);

  @Input() public isCreateFlow = true;
  @Input() public roomName?: string;
  @Output() public roomNameChange = new EventEmitter<string>();

  public nameInput = new UntypedFormControl('', [Validators.required]);

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.roomName.currentValue) {
      this.nameInput.setValue(this.roomName);
    }
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  public nextStep(): void {
    this.roomName = this.nameInput.value;
    this.roomNameChange.emit(this.roomName);
  }

  public disableApplyButton(): boolean {
    return !this.isCreateFlow && this.nameInput.value === this.roomName;
  }
}
